import { marginAttributesList } from '../system/attributes/margin';
var systemAttributeList = Object.assign(Object.assign({}, marginAttributesList), {
  theme: true
});
export var shouldForwardProp = function shouldForwardProp(property) {
  var componentPropertyList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !(property in componentPropertyList) && !(property in systemAttributeList);
};